import { Body, Box } from '../../../widgets'
import { DataGrid } from './'

export const Table = ({ rows, onRowClick, columns, defaultSortColumn, title }) => {
  return (
    <Box column fullWidth gap={8}>
      {title && <Body alt bold>{title}</Body>}

      <DataGrid
        columns={columns}
        rows={rows}
        onRowClick={onRowClick}
        defaultSortColumn={defaultSortColumn}
      />
    </Box>
  )
}